export const tryParseJson = <T>(json: string): T | undefined => {
  try {
    return JSON.parse(json) as T;
  } catch (e) {
    return undefined;
  }
};
